// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfe from '../../../form_exportacao_nfe/campos_nfe/selecao_todos_nfe';
import { Input } from '../../../../../../../common/input';

export default function CamposImpostoImportacao() {
  return (
      <FormSection name="dadosImpostoImportacao">
        <SelecaoTodosNfe nomes={ ["dadosImpostoImportacao"] } titulo="Dados do Imposto de Importação (II)"/>

        <div className="grupo-checkbox">
          <Input name="valorBcImpostoImportacao" label="Base de Cálculo do II" checkbox/>
          <Input name="despesasAduaneiraImpostoImportacao" label="Despesas aduaneiras" checkbox/>
          <Input name="valorImpostoImportacao" label="Valor do II" checkbox/>
          <Input name="iofImpostoImportacao" label="IOF" checkbox/>
        </div>
      </FormSection>
  );
}